// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__1Ux0L","footer":"style_footer__2S74F","abort":"style_abort__2_3pK","saveChecklist":"style_saveChecklist__3SQNU","submit":"style_submit__TLWgu"};